import { LocaleType } from './Locale';

const theLocale: LocaleType = {

    locale: 'kr',
    alia: 'kr',
    region: 'Korea',
    regionText: '한국',
    language: 'Korean',
    languageText: '한국어',
    appId: 8,
    acceptLanguage: 'ko-KR,ko;q=0.9',
};
export default theLocale;
